import { XMarkIcon } from '@heroicons/react/24/outline';
import { translations } from '@rchitected/locale';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  onClose?(): void;
}

export const ModalHeader: React.FC<React.PropsWithChildren<Props>> = ({ children, onClose }) => (
  <header className="relative">
    <h1 className="font-semibold">{children}</h1>

    {!!onClose && (
      <button
        className="absolute -right-2 top-1/2 -translate-y-1/2 rounded p-2 hover:bg-gray-100"
        type="button"
        onClick={onClose}
      >
        <span className="sr-only">
          <FormattedMessage id={translations.buttons.close} />
        </span>
        <XMarkIcon aria-hidden="true" className="h-5 w-5" />
      </button>
    )}
  </header>
);
